'use client';

import styles from './ImageModal.module.css';

export const ImageModal = ({
  className,
  children,
  ctaText,
  ctaOnClick,
}: {
  className?: string;
  children?: React.ReactNode | undefined;
  ctaText?: string;
  ctaOnClick?: () => void;
}) => {
  // const { width } = useWindowSize();
  return (
    <div
      className={className ? `${styles.root} ${className}` : styles.root}
      onClick={(e) => e.stopPropagation()}
      aria-hidden="true"
    >
      <div className="children-container">{children}</div>
      {ctaText && ctaText.length ? (
        <div className="sticky-container">
          <button onClick={ctaOnClick}>{ctaText}</button>
        </div>
      ) : null}
    </div>
  );
};
